import React from 'react';

const Loader = ({ isLoading, logoUrl }) => {
  return (
    <div className={`loader-overlay ${isLoading ? '' : 'loader-hidden'}`}>
      <div className="loader-content">
        {/* --- FIX: Only render the image if a logoUrl exists --- */}
        {logoUrl && <img src={logoUrl} alt="Loading..." className="loader-logo" />}
        
        <div className="progress-bar-container">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;